import type { Mission } from '../missions.ts'

export const nga: Mission = {
  id: "nga",
  name: "National Geospatial-Intelligence Agency",
  short: "NGA",
  call: "Maps",
  kind: "subagency",
  parent: "dod",
  community: "intelligence",
  url: "https://www.nga.mil/",
  established: 1996,
  palette: {
    primary: "#15159e",
    secondary: "#040726",
    accent: "#9d822f",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:US-NationalGeospatialIntelligenceAgency-2008Seal.svg",
  },
  motif: "globe",
  mission: {
    text: "The National Geospatial-Intelligence Agency (NGA) delivers world-class geospatial intelligence that provides a decisive advantage to policymakers, military service members, intelligence professionals and first responders.",
    url: "https://www.nga.mil/about/About_Us.html",
  },
  fact: {
    text: "NGA began as the National Imagery and Mapping Agency on October 1, 1996, and Congress renamed it the National Geospatial-Intelligence Agency in 2003.",
    url: "https://www.nga.mil/about/About_Us.html",
  },
  seal: {
    file: "public/seals/nga.png",
    source: "https://commons.wikimedia.org/wiki/File:US-NationalGeospatialIntelligenceAgency-2008Seal.svg",
  },
  identifier: {
    about: "https://www.nga.mil/about/About_Us.html",
    accessibility: "https://www.nga.mil/resources/Web_Privacy_&_Accessibility.html",
    foia: "https://www.nga.mil/resources/FOIA_Information.html",
    noFear: "https://www.nga.mil/resources/Equal_Employment_&_No_Fear_Act_.html",
    oig: "https://www.nga.mil/resources/oig/Office_of_the_Inspector_General.html",
    performance: "https://www.nga.mil/about/NGA_Strategy.html",
    privacy: "https://www.nga.mil/resources/Privacy_Policy.html",
  },
  media: {
    photos: [
      {
        file: "/media/nga-campus-east.jpg",
        small: "/media/nga-campus-east-sm.jpg",
        alt: "Aerial view of the NGA Campus East headquarters in Springfield, Virginia, a long curving office building around a domed atrium, surrounded by lawns, roads and forest.",
        title: "NGA Campus East, Springfield, Virginia, September 2011",
        creator: "National Geospatial-Intelligence Agency",
        source: "https://commons.wikimedia.org/wiki/File:NGA_New_HQ.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
